module.exports = __webpack_public_path__ + "img/1486707088.83f652a5.jpg";